module.exports = __webpack_public_path__ + "media/images/beauty-e45e59d45c6705e81d03f2aef9764461.jpg";